var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAllocate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "allocate_truck",
    "data-name": "allocate truck",
    transform: "translate(-1228 -650)",
    stroke: "#ff7200"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    width: 0,
    height: 0,
    rx: 5,
    transform: "translate(1228 650)",
    fill: "green"
  }), /*#__PURE__*/React.createElement("g", {
    id: "index",
    transform: "translate(1080.992 439.39)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M490.56,259.395a1.785,1.785,0,1,1-1.785-1.785A1.787,1.787,0,0,1,490.56,259.395Z",
    transform: "translate(-316.918 -35.215)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M234.18,459.181A1.785,1.785,0,1,1,232.4,457.4,1.787,1.787,0,0,1,234.18,459.181ZM222.415,457.4a1.736,1.736,0,0,0-1.267.512,1.785,1.785,0,0,0,1.235,3.058h.016a1.785,1.785,0,0,0,.015-3.57Z",
    transform: "translate(-63.393 -225.362)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M173.285,264.388h-.568a.357.357,0,0,0-.3.164,8.64,8.64,0,0,1-.56.791,8.579,8.579,0,0,1-.56-.791h0a21.351,21.351,0,0,1-2-3.9h0a.353.353,0,0,0-.017-.041,2.857,2.857,0,0,1-.269-1.032v-.09c0-.033,0-.066,0-.1a1.57,1.57,0,0,1,.007-.181c0-.065.01-.126.015-.173l.02-.126c.01-.054.019-.109.03-.155l.014-.056c.007-.028.013-.055.026-.1.018-.063.036-.123.06-.184a.377.377,0,0,0,.012-.04c.006-.011.01-.022.015-.034.023-.061.049-.122.089-.2a.356.356,0,0,0-.308-.536h-6.472a1,1,0,0,0-1,1v5.78h-.714v-4.641a1.076,1.076,0,0,0-1.071-1.071,1.072,1.072,0,0,0-1.071,1.071v.357h-.714a3.932,3.932,0,0,0-3.927,3.927v4.284a1.072,1.072,0,0,0,1.071,1.071h1.071a.379.379,0,0,0,.357-.379,2.5,2.5,0,0,1,5,.022.357.357,0,0,0,.357.357h4.284a.357.357,0,0,0,.357-.357,2.5,2.5,0,0,1,5,0,.357.357,0,0,0,.357.357h1.428a1.072,1.072,0,0,0,1.071-1.071v-2.856a1.072,1.072,0,0,0-1.071-1.071Zm-18.564-.357a3.217,3.217,0,0,1,3.213-3.213h.714v2.142H157.8a1.046,1.046,0,0,0-.594.181l-1.79,1.188a.349.349,0,0,1-.194.059h-.5Z",
    transform: "translate(0 -35.211)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M453.573,230.963c-.171,0-.364,0-1.161-1.235a21.934,21.934,0,0,1-2.073-4.036.179.179,0,0,1-.009-.023,5.37,5.37,0,0,1-.323-1.339c0-.05,0-.1,0-.151a2.3,2.3,0,0,1,.009-.238c0-.059.01-.133.018-.207l.023-.15c.014-.076.026-.144.041-.211l.013-.052c.011-.046.023-.093.038-.139a2.424,2.424,0,0,1,.079-.238.378.378,0,0,1,.028-.076c.031-.081.066-.162.1-.239l.012-.022a.1.1,0,0,1,.006-.014,3.569,3.569,0,0,1,6.767,1.587c0,1.344-1.4,3.87-1.833,4.613-.208.357-.4.672-.578.938-.794,1.232-.988,1.232-1.158,1.232Zm-2.566-5.525a21.339,21.339,0,0,0,2,3.9,8.633,8.633,0,0,0,.561.792,8.585,8.585,0,0,0,.56-.791c.171-.259.358-.563.559-.908a11.693,11.693,0,0,0,1.737-4.254,2.855,2.855,0,0,0-5.394-1.309.33.33,0,0,1-.042.083c-.026.054-.054.118-.078.182,0,.012-.009.022-.015.034s-.008.029-.012.04a1.876,1.876,0,0,0-.06.184c-.013.041-.02.069-.026.1l-.014.056c-.011.046-.02.1-.03.155l-.02.126c-.005.047-.011.109-.015.173a1.594,1.594,0,0,0-.007.18c0,.03,0,.063,0,.1a4.674,4.674,0,0,0,.279,1.141.179.179,0,0,1,.009.021Z",
    transform: "translate(-281.716)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M456.929,258.592a.358.358,0,0,1-.318-.523h0l0-.006c.01-.019.031-.058.038-.069a.373.373,0,0,1,.612.036.356.356,0,0,1-.02.368l-.148-.1.145.1-.032-.022.035.024a.352.352,0,0,1-.314.192Zm.032-.389-.011-.007Z",
    transform: "translate(-287.967 -35.444)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllocate);
export default __webpack_public_path__ + "static/media/allocate.31c3ba7bb5416c189857a463c98d38f5.svg";
export { ForwardRef as ReactComponent };